import {createArray, findMaxE} from "@Common/utils/collections";
import {chain}                 from "@Common/utils/fs";

export const calculateGrid = ({totalWidth, minWidth, maxWidth, minGap, maxGap, count, stretch}) => {
    const maxColCount = Math.floor(totalWidth / (minWidth + minGap)) || 1;

    const colCount = count <= maxColCount ? (
        count
    ) : findMaxE(
        createArray(Math.ceil(maxColCount / 2)).map((e) => maxColCount - e).filter((cc) => cc > 0),
        (cc) => chain(
            count % cc,
            (lcc) => lcc === 0 ? cc : lcc,
            (lcc) => lcc - cc,
        ),
        (delta) => delta === 0,
    );


    const ratio = (() => {
        const max = (maxWidth * colCount) + (maxGap * (colCount - 1));
        const min = (minWidth * colCount) + (minGap * (colCount - 1));
        // const min = minWidth + minGap;
        if (max < totalWidth) {
            return 1;
        }
        return (totalWidth - min) / (max - min);
    })();


    const applyColCount = (colCount) => {
        const rowCount = Math.ceil(count / colCount);
        return ({
            rowCount,
            lastRowColCount: count % colCount,
            colCount: rowCount === 1 ? count : colCount,
        });
    };
    const applyRatio = (ratio) => ({
        cellWidth: minWidth + (maxWidth - minWidth) * ratio,
        gapSize  : minGap   + (maxGap   - minGap  ) * ratio,
    });

    if (ratio < 1 || !stretch) {
        // console.log({
        //     ...applyColCount(colCount),
        //     ...applyRatio(ratio),
        // });
        return {
            ...applyColCount(colCount),
            ...applyRatio(ratio),
        };
    }

    return stretch1({
        ...applyColCount(colCount),
        cellWidth: maxWidth,
        gapSize: maxGap,
        totalWidth,
    });
};

const stretch1 = ({totalWidth, ...r}) => {
    const usedWidth = r.colCount * r.cellWidth + (r.colCount - 1) * r.gapSize;
    const remainWidth = totalWidth - usedWidth;
    return {
        ...r,
        cellWidth: r.cellWidth + remainWidth / r.colCount,
    };
};
